import React from 'react';
import { IOrderTagData } from '../../types/order/tags/IOrderTagData';
import { ColorBadgeTW } from './BadgeTW';
import { Tooltip } from '../../ui-toolkit';

const colorNamesDict = {
  normal: 'bg-gray-100 text-gray-800',
  escalation: 'bg-red-50 text-red-700',
};

export const TagBadge: React.FC<{ orderTag: IOrderTagData }> = ({ orderTag: { value, tag } }) => {
  const color = colorNamesDict[tag.type] ?? 'bg-gray-100 text-gray-800';
  if (!value) {
    return <ColorBadgeTW className={color}>{tag.label}</ColorBadgeTW>;
  }
  return (
    <Tooltip tooltipContent={value} trigger={'hover'} placement={'bottom'}>
      <ColorBadgeTW className={color}>{tag.label}</ColorBadgeTW>
    </Tooltip>
  );
};
